import { IAssocUserCatalog } from '../interfaces/createUserOrRoleCatalog';
import { CatalogType } from '../enums/catalogType.enum';
import { UserWithRole } from './userWithRole';

export class AssocUserCatalog implements IAssocUserCatalog {
    public idCatalog: number;
    public type: CatalogType;
    public userRole: UserWithRole[];
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/assocUserCatalog.ts